import { useEffect } from 'react';

export const useDialogStyles = () => {
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      .custom-dialog .p-dialog-content {
        padding: 1.5rem;
        color: #1f2937;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
      }
      .clean-input {
        width: 100%;
        height: 38px;
        padding: 0 12px;
        border: 1px solid #e5e7eb;
        border-radius: 6px;
        background-color: #ffffff;
        font-size: 13.5px;
        color: #322915;
        transition: border-color 0.15s ease;
        box-sizing: border-box;
      }
      .clean-input:focus {
        outline: none;
        border-color: #322915;
      }
      .clean-textarea {
        width: 100%;
        padding: 10px 12px;
        border: 1px solid #e5e7eb;
        border-radius: 6px;
        background-color: #ffffff;
        font-size: 13.5px;
        color: #322915;
        transition: border-color 0.15s ease;
        resize: vertical;
        box-sizing: border-box;
      }
      .clean-textarea:focus {
        outline: none;
        border-color: #322915;
      }
      .clean-select {
        width: 100%;
        height: 38px;
        padding: 0 12px;
        border: 1px solid #e5e7eb;
        border-radius: 6px;
        background-color: #ffffff;
        font-size: 13.5px;
        color: #322915;
        transition: border-color 0.15s ease;
        box-sizing: border-box;
        appearance: auto;
        cursor: pointer;
      }
      .clean-select:focus {
        outline: none;
        border-color: #322915;
      }
      .accordion-header {
        border-bottom: 1px solid #e5e7eb;
        padding: 12px 0;
        margin-bottom: 12px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        user-select: none;
        cursor: pointer;
      }
      .accordion-title {
        font-size: 12.5px;
        font-weight: 600;
        color: #322915;
        letter-spacing: 0.05em;
        text-transform: uppercase;
        display: flex;
        align-items: center;
        gap: 8px;
      }
      .accordion-title i {
        color: #6b7280;
        font-size: 14px;
      }
      .static-section-title {
        font-size: 12.5px;
        font-weight: 600;
        color: #322915;
        letter-spacing: 0.05em;
        text-transform: uppercase;
        margin-top: 20px;
        margin-bottom: 12px;
        padding-top: 14px;
        border-top: 1px solid #e5e7eb;
        display: flex;
        align-items: center;
        gap: 8px;
      }
      .static-section-title i {
        color: #6b7280;
        font-size: 14px;
      }
      .field-label {
        font-size: 12px;
        color: #6b7280;
        display: block;
        margin-bottom: 4px;
      }
      .brand-btn-primary {
        background-color: #322915 !important;
        border-color: #322915 !important;
        color: #ffffff !important;
        border-radius: 6px !important;
        font-weight: 500 !important;
      }
      .brand-btn-primary:hover {
        opacity: 0.9;
      }
      .devis-card {
        border: 1px solid #e5e7eb;
        border-radius: 6px;
        padding: 14px;
        background: #fafafa;
      }
      .btn-outlined-clean {
        border-color: #e5e7eb !important;
        color: #322915 !important;
        font-size: 13px !important;
        border-radius: 6px !important;
      }
      .btn-outlined-clean:hover {
        background-color: #f9fafb !important;
      }
      .status-select-wrapper {
        padding: 12px 0 8px 0;
        display: flex;
        align-items: center;
        gap: 12px;
      }
      .status-select-wrapper .field-label {
        margin-bottom: 0;
        font-weight: 500;
        color: #322915;
        font-size: 12.5px;
        text-transform: uppercase;
        letter-spacing: 0.05em;
      }
      .status-select-wrapper .clean-select {
        width: 180px;
        flex-shrink: 0;
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);
};